import { initNewSlider } from '../main.js';
import { initLinksNumber } from '../main.js';
import { getGroupes } from '../main.js';

class Units
{
    constructor(transitions)
    {
		this.transitions = transitions;
		this.totalClicks = {};
        this.init();
    }

    async init()
	{
		if(document.querySelector('.project-units .types-form select')) {
			let typeDropDown = document.querySelector('.project-units .types-form select');
			typeDropDown.addEventListener('change', async (e) =>
			{
				let target = e.currentTarget;
				let plus = document.querySelector('.units-container .plus');
				gsap.to(plus, {display:"none", alpha:0, duration:0.2, ease:"power3.out", overwrite:true});
				let heightUnits = document.querySelector('.project-units .units').offsetHeight;
				gsap.set('.project-units .units', {height:heightUnits});
				gsap.to('.project-units .units', {alpha:0, duration:0.3, ease:"power3.out", onComplete:async () =>
				{
					document.querySelector('.project-units .units').innerHTML = "";
					
					let type = target.value;
					let typeLabel = target.options[target.selectedIndex].text;
					
					let parent = target.parentElement.parentElement.parentElement;
					let id_projet = parent.querySelector('.units').dataset.idprojet;
					let appartements = parent.querySelector('.units').dataset.appartements;
					let appartements_id = appartements.split(',');
					let sequence = parent.querySelector('.units').dataset.sequence;
					let sequence_id = sequence.split(",");
					
					//let groupes = parent.querySelector('.units').dataset.groupes;
					let groupes = await getGroupes();
					//if(groupes != "") {
						//groupes = JSON.parse(groupes);
					//}
					
					let data = new FormData();
					data.append('action', 'get_units_groupes_type');
					data.append('type', typeLabel);
					data.append('id_projet', id_projet);
					data.append('current_index', 0);
					data.append('groupes', JSON.stringify(groupes));
					data.append('sequence', JSON.stringify(sequence_id));
					
					fetch(mainscript.ajaxurl,
					{
						method: 'POST',
						body: data
					})
					.then(response => response.text())
					.then(data => {
						let result = JSON.parse(data);
						let content = result.data.content;
						let newIndex = result.data.current_index;
						let randomNumber = result.data.randomNumber;
						let selector = result.data.selector;
						
						if(newIndex == 99999) {
							
						} else {
							gsap.set(plus, {y:-10, display:"inline-block"});
							gsap.to(plus, {delay:0.5, alpha:1, y:0, duration:0.4, ease:"power3.out"});
						}
						parent.querySelector(".units").dataset.currentindex = newIndex;

						if(content != "") {
							parent.querySelector('.units').innerHTML += content;
						} else {
							let lang = document.querySelector('html').getAttribute('lang');
							if(lang == "fr-FR") {
								parent.querySelector('.units').innerHTML = "<p style='width:100%; text-align:center;'>Aucun résultat.</p>";
							} else {
								parent.querySelector('.units').innerHTML = "<p style='width:100%; text-align:center;'>No results.</p>";
							}
						}

						gsap.set('.project-units .units', {height:"auto"});
						let newHeight = document.querySelector('.project-units .units').offsetHeight;
						gsap.set('.project-units .units', {height:heightUnits});
						gsap.to('.project-units .units', {height:newHeight, alpha:1, duration:0.7, ease:"power3.out", onComplete:() =>
						{
							gsap.set('.project-units .units', {height:"auto"});
						}});

						initNewSlider(selector);

						this.transitions.setupTextTop('.unit.text-top-' + randomNumber);
						initLinksNumber(".btn-" + randomNumber);

						window.dispatchEvent(new Event('resize'));
					});
				}});               
			});
		}
		
		if(document.querySelectorAll('.units-container .plus')) {

            document.querySelectorAll('.units-container .plus').forEach(plus =>
            {
                plus.addEventListener('click', async (e) => 
                {
                    e.preventDefault();

					let plus = e.currentTarget;
                    let parent = e.currentTarget.parentElement.parentElement;
                    let currentIndex = parent.querySelector('.units').dataset.currentindex;
                    
                    let id_projet = parent.querySelector('.units').dataset.idprojet;
                    let appartements = parent.querySelector('.units').dataset.appartements;
                    let appartements_id = appartements.split(',');
                    
                    //let groupes = parent.querySelector('.units').dataset.groupes;
					let groupes = await getGroupes();
                    //if(groupes != "") {
                        //groupes = JSON.parse(groupes);
                    //}
                    
                    let data = new FormData();
                    if(groupes == "") {
                        // Page des résutltats de recherche (on affiche pas les groupes d'appartements)
                        data.append('action', 'get_units');
                        data.append('id_projet', id_projet);
                        data.append('current_index', currentIndex);
                        data.append('ids', JSON.stringify(appartements_id));
						this.totalClicks[id_projet] = this.totalClicks[id_projet] + 1 || 1;
						if(this.totalClicks[id_projet] == 2) {
							let projetBtn = parent.querySelector('.voir-plus-projet');
							gsap.to(projetBtn, {delay:0.5, alpha:1, display:"inline-block", duration:0.5, ease:"power3.out"});
						}
                    } else {

						//Page projet (avec groupes d'appartements)
                        let sequence = parent.querySelector('.units').dataset.sequence;
                        let sequence_id = sequence.split(",");

                        let type = document.querySelector('.project-units .types-form select').value;
                        let typeLabel = document.querySelector('.project-units .types-form select').options[document.querySelector('.project-units .types-form select').selectedIndex].text;

                        if(type == "") {
                            data.append('action', 'get_units_groupes');
                        } else {
                            data.append('action', 'get_units_groupes_type');
                            data.append('type', typeLabel);
                        }

                        data.append('id_projet', id_projet);
                        data.append('current_index', currentIndex);
                        data.append('groupes', JSON.stringify(groupes));
                        data.append('sequence', JSON.stringify(sequence_id));
                    }
                    
                    fetch(mainscript.ajaxurl,
                    {
                        method: 'POST',
                        body: data
                    })
                    .then(response => response.text())
                    .then(data => {
                        let result = JSON.parse(data);
                        let content = result.data.content;
                        let newIndex = result.data.current_index;
                        let randomNumber = result.data.randomNumber;
                        let selector = result.data.selector;
                        
                        if(newIndex == 99999) {
                            gsap.to(plus, {display:"none", alpha:0, duration:0.2, ease:"power3.out", overwrite:true});
                        } else {
                            gsap.set(plus, {y:-10, display:"inline-block"});
                            gsap.to(plus, {delay:0.5, alpha:1, y:0, duration:0.4, ease:"power3.out"});
                        }
                        
                        parent.querySelector(".units").dataset.currentindex = newIndex;
                        
                        
                        parent.querySelector('.units').insertAdjacentHTML('beforeend', content);
                        //parent.querySelector('.units').innerHTML += content;
                        
                        initNewSlider(selector);

                        this.transitions.setupTextTop('.unit.text-top-' + randomNumber);
                        initLinksNumber(".btn-" + randomNumber);

						window.dispatchEvent(new Event('resize'));
                    });
                });
            });
        }
	}
}

export default Units;